import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function list(params) {
  const newParams = { ...params };
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }

  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }

  const url = `/subscription?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.subscription.list: url = ${url}`);

  return request({
    url,
    method: "get",
    data: newParams,
  });
}


function addSubs(params) {
  ENABLE_API_DBG &&
    console.log(`api.subscribe.addSubs: params = ${JSON.stringify(params)}`);
  return request({
    url: `/subscription`,
    method: "post",
    data: params,
  });
}

function removeSubs(itemId) {
  const url = `/subscription/${itemId}`;
  ENABLE_API_DBG &&
    console.log(`api.subscription.removeSubs: url = ${url}`);
  return request({
    url,
    method: "delete",
  });
}
function batchSubs(params) {
  ENABLE_API_DBG &&
    console.log(`api.subscribe.batchAddSubs: params = ${JSON.stringify(params)}`);
  return request({
    url: `/subscription/batch`,
    method: "post",
    data: params,
  });
}
function setApprNeed(itemId, params) {
  return changeSubs(itemId, params);
}

function changeSubs(itemId, params) {
  ENABLE_API_DBG &&
    console.log(`api.subscription.changeSubs: params = ${JSON.stringify(params)}`);
  return request({
    url: `/subscription/${itemId}`,
    method: "patch",
    data: params,
  });
}

export default {
  list,
  addSubs,
  removeSubs,
  setApprNeed,
  changeSubs,
  batchSubs,
};
